import TurnedInNotOutlinedIcon from '@mui/icons-material/TurnedInNotOutlined';
import TurnedInOutlinedIcon from '@mui/icons-material/TurnedInOutlined';
import { Button } from '@mui/material';
import { useCallback } from 'react';
import { useValuationsStore } from '@/pages/ValuationsV2/store/valuationsStore';
import { pxToRem } from '@/utils/pxToRem';
import { useHandleWatchList } from '../../hooks/useHandleWatchList';

type AddWatchListProps = {
  id?: string;
};

const AddWatchList = ({ id }: AddWatchListProps) => {
  const { isInWatchList, toggleWatchList } = useHandleWatchList();
  const selectedAsset = useValuationsStore.use.selectedAssetDetails();

  const isChecked = selectedAsset?.id ? isInWatchList(selectedAsset.id) : false;

  const handleToggle = useCallback(() => {
    if (!selectedAsset) return;
    toggleWatchList(selectedAsset);
  }, [selectedAsset, toggleWatchList]);

  return (
    <Button
      id={id}
      disabled={selectedAsset === null}
      startIcon={isChecked ? <TurnedInOutlinedIcon /> : <TurnedInNotOutlinedIcon />}
      data-id='watchlist-checkbox-control'
      onClick={handleToggle}
      color='secondary'
      size='small'
      sx={{
        fontSize: pxToRem(12),
      }}
    >
      {isChecked ? 'REMOVE FROM WATCHLIST' : 'ADD TO WATCHLIST'}
    </Button>
  );
};

export { AddWatchList };
